import { render, staticRenderFns } from "./ClientDetailsForm.vue?vue&type=template&id=ede77798&scoped=true&"
import script from "./ClientDetailsForm.vue?vue&type=script&lang=js&"
export * from "./ClientDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetailsForm.vue?vue&type=style&index=0&id=ede77798&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede77798",
  null
  
)

export default component.exports